<template>
  <div class="ac-wrapper" ref="search" :class="isOpen ? 'opened': 'closed'">
    <div class="icon-input close-icon" v-show="isOpen" @click="closeSearchList">
      <span class="close-icon-icon color-2-63">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 15.002 15.002" style="enable-background:new 0 0 15.002 15.002;" xml:space="preserve">
          <polygon id="XMLID_2_" class="st0" points="7.501,9.794 2.293,15.002 0,12.709 5.208,7.501 0,2.293 2.293,0.001 7.501,5.208
            12.709,0 15.002,2.293 9.794,7.501 15.002,12.709 12.709,15.002 "/>
        </svg>
      </span>
    </div>
    <div class="icon-input open-icon">
      <span class="open-icon-icon" :class="isOpen ? 'color-2-30': 'color-1-100'">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 33.643 32.855" style="enable-background:new 0 0 33.643 32.855;" xml:space="preserve">
          <path id="XMLID_34_" class="st0" d="M33.204,30.294l-8.119-8.119c1.716-2.314,2.744-5.166,2.744-8.261
            C27.829,6.243,21.587,0,13.914,0S0,6.243,0,13.915s6.242,13.914,13.915,13.914c3.497,0,6.689-1.307,9.136-3.445l8.032,8.032
            c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439s0.439-0.677,0.439-1.061S33.497,30.587,33.204,30.294z
             M13.914,24.829C7.896,24.829,3,19.932,3,13.915S7.896,3,13.914,3s10.915,4.896,10.915,10.914S19.932,24.829,13.914,24.829z"/>
        </svg>
      </span>
    </div>
    <input
      aria-label="Search input"
      title="Search input"
      :disabled="!getIsLoggedIn"
      class="ac-input"
      :class="isOpen ? 'opened': 'closed'"
      v-model.trim="searchQuery"
      :placeholder="getIsLoggedIn ? 'Search' : 'You need to login to use the search'"
      v-on:keydown="keyDownPressed($event)"
      @blur="searchLeave($event)"
      @input="onInput($event.target.value)"
      @keyup.esc="close" />
      <div class="ac-results border-1-20" v-if="isOpen">
        <div class="ac-filters">
          <ul class="ac-filters-list">
            <li class="ac-filters-list__item first">
              <v-select placeholder="Filter by type"
                        value.sync="selectedType"
                        :on-change="selectType"
                        :on-input="startsTyping"
                        :options="getContentTypeForSelect">
                <template slot="option" slot-scope="option" :selected="option.value === 0 ? 'selected' : ''">
                  <span>{{option.label}}</span>
                </template>
              </v-select>
            </li>
          </ul>
          <ul class="ac-list">
            <li v-for="(option, index) in optionsComputed"
              class="ac-filters-list__item border-1-20 background-1-20-hover color-2-100"
              :class="{'hight-contrast-dropdown': selectedHightCont === 1}"
              @click="select(option.id, option.title, option.isArticle)"
                style="min-height: 66px;"
              @keydown.space.enter="select(option.id, option.title, option.isArticle)"
              @mouseenter="highlightedPosition = index"
              tabindex="0">
              <div>
                <span :class="option.itemClass">
                <span v-if="option.itemClass === 'screentext'">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="266 -229.629 548.173 475.087" style="enable-background:new 266 -229.629 548.173 475.087;" xml:space="preserve">
                    <g>
                      <path class="st0" d="M800.75-216.207c-8.945-8.945-19.694-13.422-32.261-13.422H311.681c-12.562,0-23.313,4.477-32.264,13.422
                        C270.471-207.259,266-196.509,266-183.946v310.633c0,12.566,4.471,23.315,13.417,32.265c8.951,8.945,19.702,13.414,32.264,13.414
                        h155.318c0,7.231-1.524,14.661-4.57,22.269c-3.044,7.614-6.09,14.273-9.136,19.981c-3.042,5.715-4.565,9.897-4.565,12.56
                        c0,4.948,1.807,9.24,5.424,12.847c3.615,3.621,7.898,5.435,12.847,5.435h146.179c4.949,0,9.233-1.813,12.848-5.435
                        c3.62-3.606,5.427-7.898,5.427-12.847c0-2.468-1.526-6.611-4.571-12.415c-3.046-5.801-6.092-12.566-9.134-20.267
                        c-3.046-7.71-4.569-15.085-4.569-22.128h155.318c12.56,0,23.309-4.469,32.254-13.414c8.949-8.949,13.422-19.698,13.422-32.265
                        v-310.633C814.176-196.509,809.699-207.259,800.75-216.207z M777.627,53.596c0,2.475-0.903,4.613-2.711,6.424
                        c-1.81,1.804-3.952,2.707-6.427,2.707H311.681c-2.473,0-4.615-0.903-6.423-2.707c-1.807-1.817-2.712-3.949-2.712-6.424v-237.542
                        c0-2.475,0.902-4.615,2.712-6.423c1.809-1.805,3.951-2.712,6.423-2.712h456.815c2.471,0,4.617,0.904,6.42,2.712
                        c1.808,1.809,2.711,3.949,2.711,6.423V53.596z"/>
                      <path class="st0" d="M578.895-30.559H448.674c-7.346,0-13.303,7.34-13.303,16.403s5.957,16.403,13.303,16.403h130.221
                        c7.346,0,13.303-7.34,13.303-16.403S586.242-30.559,578.895-30.559z"/>
                      <path class="st0" d="M648.895-112.601H448.674c-7.346,0-13.303,7.34-13.303,16.404c0,9.064,5.957,16.403,13.303,16.403h200.221
                        c7.346,0,13.303-7.34,13.303-16.403C662.199-105.262,656.242-112.601,648.895-112.601z"/>
                    </g>
                  </svg>
                </span>
                <span v-else-if="option.itemClass === 'casestudy'">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="496.239 -496 437.522 512" style="enable-background:new 496.239 -496 437.522 512;" xml:space="preserve">
                    <g>
                      <path class="st0" d="M671.136-108.138H529.342v-242.759h95.449c9.142,0,16.552-7.41,16.552-16.552v-95.448h156.689v214.621
                        c0,9.137,7.41,16.552,16.552,16.552s16.552-7.41,16.552-16.552v-231.172c-0.001-9.142-7.41-16.552-16.552-16.552H624.791
                        c-4.392,0-8.601,1.743-11.702,4.85l-112,112c-3.106,3.101-4.85,7.316-4.85,11.702v275.862c0,9.142,7.41,16.552,16.552,16.552
                        h158.345c9.142,0,16.552-7.41,16.552-16.552S680.278-108.138,671.136-108.138z M552.746-384l55.493-55.493V-384H552.746z"/>
                      <path class="st0" d="M594.446-312.828c-9.142,0-16.552,7.41-16.552,16.552s7.41,16.552,16.552,16.552h138.483
                        c9.148,0,16.552-7.41,16.552-16.552c-0.001-9.142-7.41-16.552-16.552-16.552H594.446z"/>
                      <path class="st0" d="M676.929-246.621h-82.483c-9.142,0-16.552,7.41-16.552,16.552s7.41,16.552,16.552,16.552h82.483
                        c9.148,0,16.552-7.41,16.552-16.552S686.071-246.621,676.929-246.621z"/>
                      <path class="st0" d="M928.851-12.309l-44.995-44.54c10.581-15.184,16.797-33.626,16.797-53.496
                        c0-51.719-42.075-93.793-93.793-93.793c-51.719,0-93.793,42.074-93.793,93.793s42.074,93.793,93.793,93.793
                        c19.919,0,38.404-6.246,53.609-16.875l45.094,44.638c3.228,3.194,7.432,4.789,11.641,4.789c4.259,0,8.524-1.639,11.763-4.905
                        C935.406,4.596,935.351-5.881,928.851-12.309z M746.17-110.345c0-33.462,27.228-60.69,60.69-60.69s60.69,27.228,60.69,60.69
                        c-0.001,33.462-27.228,60.69-60.69,60.69S746.17-76.883,746.17-110.345z"/>
                    </g>
                  </svg>
                </span>
                <span v-else-if="option.itemClass === 'template'">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="-429 388.404 25.408 24.561" style="enable-background:new -429 388.404 25.408 24.561;" xml:space="preserve">
                    <g id="Clip-2">
                    </g>
                    <path class="st0" d="M-403.621,391.797c0.061-0.651-0.456-1.157-1.114-1.091c-3.086-0.049-6.171,0-9.26-0.017v-2.285h-1.726
                      c-4.425,0.78-8.853,1.525-13.278,2.29c0,6.66-0.003,13.323,0,19.987c4.402,0.762,8.807,1.491,13.2,2.285h1.804v-2.285
                      c2.889,0,5.776-0.006,8.665,0.008c0.49-0.023,1.036,0.014,1.457-0.282c0.338-0.511,0.251-1.151,0.28-1.727
                      C-403.633,403.052-403.572,397.423-403.621,391.797z M-419.37,404.566c-0.482,0.249-1.204-0.011-1.775,0.029
                      c-0.384-1.891-0.831-3.77-1.175-5.669c-0.338,1.845-0.776,3.673-1.163,5.506c-0.554-0.028-1.111-0.062-1.669-0.1
                      c-0.479-2.513-1.042-5.009-1.489-7.528c0.493-0.023,0.99-0.043,1.484-0.06c0.297,1.819,0.635,3.63,0.895,5.452
                      c0.407-1.868,0.823-3.736,1.227-5.604c0.549-0.031,1.097-0.054,1.645-0.083c0.384,1.928,0.776,3.853,1.192,5.772
                      c0.326-1.982,0.687-3.958,1.036-5.938c0.578-0.02,1.155-0.051,1.729-0.086C-418.086,399.025-418.657,401.816-419.37,404.566z
                       M-404.906,409.227h-9.188v-2.136v-1.068v-1.335v-1.068v-1.217h4.098c0.291,0,0.527-0.35,0.527-0.781
                      c0-0.432-0.236-0.781-0.527-0.781h-4.098v-0.958v-1.068v-0.037h6.098c0.291,0,0.527-0.376,0.527-0.839s-0.236-0.839-0.527-0.839
                      h-6.098v-0.688v-1.335v-1.068v-1.869h9.188V409.227z"/>
                  </svg>
                </span>
                <span v-else-if="option.itemClass === 'video'">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="-296 391.193 24 17.711" style="enable-background:new -296 391.193 24 17.711;" xml:space="preserve">
                    <g>
                      <polygon id="path-1_2_" class="st0" points="-296,391.193 -296,408.904 -272,408.904 -272,391.193 	"/>
                    </g>
                    <g id="Welcome">
                      <g id="Search-Drop-Down-Menu" transform="translate(-457.000000, -212.000000)">
                        <g id="Page-1" transform="translate(457.000000, 212.000000)">
                          <g id="Clip-2">
                          </g>
                          <path id="Fill-1" class="st1" d="M-279.841,400.693l-6.429,3.8c-0.497,0.294-1.125-0.066-1.125-0.645v-7.6
                            c0-0.579,0.628-0.939,1.125-0.645l6.429,3.8C-279.351,399.693-279.351,400.404-279.841,400.693 M-272.396,393.351
                            c-0.084-0.699-0.752-1.358-1.468-1.458c-6.848-0.932-13.423-0.932-20.271,0c-0.716,0.101-1.384,0.76-1.468,1.458
                            c-0.529,4.45-0.529,8.946,0,13.396c0.084,0.699,0.752,1.358,1.468,1.458c6.848,0.932,13.423,0.932,20.271,0
                            c0.716-0.101,1.384-0.76,1.468-1.458C-271.868,402.297-271.868,397.8-272.396,393.351"/>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                <span v-else-if="option.itemClass === 'document'">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="557.9 -470.6 672.9 849.199" style="enable-background:new 557.9 -470.6 672.9 849.199;" xml:space="preserve">
                    <g>
                      <path class="st0" d="M894.3,378.599h283.6c29.2,0,52.9-23.699,52.9-52.898V-362.2v-55.5c0-29.2-23.7-52.9-52.9-52.9H894.3H800v17.5
                          c0.199,1.8,0.3,3.7,0.3,5.6v115.3v29.6c0,41.1-33.4,74.5-74.5,74.5h-29.6H580.9c-1.5,0-3.1-0.1-4.6-0.2h-18.4v554.001
                          c0,29.199,23.7,52.898,52.9,52.898h58H894.3L894.3,378.599z M905,105.4H720.1c-13.8,0-25-12.393-25-27.66
                          c0-15.27,11.2-27.66,25-27.66h185c13.8,0,25,12.391,25,27.66C930.1,93.007,918.8,105.4,905,105.4z M720.1-85.6H1060
                          c13.8,0,25,12.544,25,28s-11.2,28-25,28H720.1c-13.8,0-25-12.544-25-28S706.3-85.6,720.1-85.6z"/>
                      <path class="st0" d="M580.9-258.1h144.9c0.1,0,0.3,0,0.4,0c24.2-0.2,43.8-19.8,44-44c0-0.1,0-0.3,0-0.4v-145
                          c0-13.4-11-22.3-22.399-22.3c-5.5,0-11,2-15.6,6.6L565.1-296.1C551.1-282.1,561-258.1,580.9-258.1z"/>
                    </g>
                  </svg>
                </span>
              </span>
              </div>
              <div class="ac-content">
                <span class="ac-title" v-if="option.title">{{option.title}}</span>
                <!--<div class="ac-description" v-if="option.content">{{option.content}}</div>-->
              </div>
              <!-- END:.ac-content -->
            </li>
            <li v-if="moreResults" class="more-results border-1-20">
              <button type="button" class="ac-blocktitle ac-more color-2-100" @click="seeMore()">
                See all search results
                <span class="ac-more-icon color-1-100">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 11 6.243" style="enable-background:new 0 0 11 6.243;" xml:space="preserve">
                    <path id="XMLID_4_" class="st0" d="M10.923,3.503c0.101-0.244,0.101-0.519,0-0.764c-0.051-0.123-0.125-0.234-0.217-0.327l-2.12-2.12
                      c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l0.414,0.414H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h6.586L7.172,4.535
                      c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l2.12-2.12
                      C10.799,3.737,10.872,3.626,10.923,3.503z"/>
                  </svg>
                </span>
              </button>
            </li>
          </ul>
        </div>
        <!-- END:ac-list -->
      </div>
      <!-- END:.ac-results -->
  </div>
  <!-- END:ac-wrapper -->
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'
import { directive as onClickaway } from 'vue-clickaway'

export default {
  name: 'autocomplete-input',
  data () {
    return {
      searchQuery: '',
      isOpen: false,
      page: 1,
      limit: 6,
      moreResults: false,
      highlightedPosition: 0,
      server: api.serverURL,
      options: [],
      selectedType: 0,
      selectedTags: null,
      isTyping: false,
      query: {},
      lastSearch: ''
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getAccessToken',
      'types',
      'getContentTypeForSelect',
      'getContentTypeIdByTitle',
      'tags',
      'getTagTitles',
      'getTagIdByNames',
      'selectedHightCont',
      'BlueYelBlue',
      'isAdmin'
    ]),
    optionsComputed () {
      let options = this.options.map(option => {
        let cutTitle
        let title = option.title.split(' ')
        if (title.length > 8) {
          cutTitle = title.splice(0, 9).join(' ') + '...'
        } else {
          cutTitle = title.join(' ')
        }
        let itemType = option.content_type.type
        let itemClass
        switch (this.selectedHightCont) {
          case 0:
            itemClass = itemType.toLowerCase().replace(/\s/g, '')
            break
          case 1:
            itemClass = itemType.toLowerCase().replace(/\s/g, '')
            break
          case 2:
            itemClass = itemType.toLowerCase().replace(/\s/g, '')
            break
        }
        return {
          id: option.id,
          title: cutTitle,
          isArticle: option.is_article,
          itemClass
        }
      })
      return options
    },
    startsTyping () {
      let filters = document.querySelectorAll('.ac-filters')
      if (this.moreResults !== true && filters.length) {
        filters[0].style.marginBottom = 0
      }
    },
    tokenComputed () {
      return localStorage.getItem('token')
    }
  },
  methods: {
    ...mapActions([
      'getTypes',
      'getTags'
    ]),
    onInput (value) {
      this.open(value)
      if (value === '') {
        this.close()
        this.selectedType = 0
      } else {
        if (this.getIsLoggedIn) {
          this.fetchContent()
        }
      }
    },
    clear () {
      this.searchQuery = ''
    },
    fetchContent () {
      // variables
      let queryString = `${api.URLS.search}&page=${this.page}`
      let searchQuery = this.searchQuery
      // END:variables
      if (searchQuery.length) {
        queryString += `&search=${searchQuery}`
        this.query['search'] = searchQuery
      }
      if (this.selectedType > 0) {
        queryString += `&contentType[0]=${this.selectedType}`
        this.query['content-type'] = this.selectedType
      }
      if (this.selectedTags) {
        queryString += `&tags[]=${this.selectedTags}`
      }
      this.$http.get(`${queryString}`, api.headersAuthSettings)
      .then((res) => {
        let resData = res.body.data
        if (!resData.items) {
          this.lastSearch = this.searchQuery
        }
        this.options = resData.items ? resData.items : []
        this.moreResults = resData.page
      })
      .catch((err) => console.error(err))
    },
    select (id, title, isArticle) {
      this.close()
      this.clear()
//      this.$router.push({name: 'content', params: {id: id}})
      if (window._paq) {
        window._paq.push(['trackEvent', 'Search', 'clicked_result', title])
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'clicked_result',
      //     eventLabel: title,
      //     eventValue: 1,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
      if (isArticle) {
        this.$router.push({name: 'content', params: {id: id}})
      } else {
        if (this.isAdmin) {
          this.$router.push({
            name: 'company-task',
            params: {
              companyId: 2,
              id: id
            }
          })
        } else {
          this.$router.push({name: 'task', params: {id: id}})
        }
      }
    },
    open (value) {
      this.isOpen = !!value
    },
    close () {
      this.isOpen = false
      this.page = 1
    },
    selectType (val) {
      if (val) {
        this.selectedType = val.value
      } else {
        this.selectedType = 0
      }
      if (window._paq) {
        let filterLabel = this.getContentTypeForSelect.find((item) => item.value === this.selectedType)
        window._paq.push(['trackEvent', 'Search', 'filter', filterLabel.label])
      }
      // if (window.ga) {
      //   let filterLabel = this.getContentTypeForSelect.find((item) => item.value === this.selectedType)
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: filterLabel.label,
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }

      this.fetchContent()
    },
    selectTags (val) {
      if (val) {
        this.selectedTags = val.value
      } else {
        this.selectedTags = null
      }
      this.fetchContent()
    },
    seeMore () {
      this.close()
      this.$router.push({path: '/search-results', query: this.query})
      if (window._paq) {
        window._paq.push(['trackEvent', 'Search', 'filter', 'see all results'])
      }
      // if (window.ga) {
      //   window.ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Search',
      //     eventAction: 'filter',
      //     eventLabel: 'see all results',
      //     page: location.pathname,
      //     location: location.href
      //   })
      // }
    },
    closeSearchList () {
      let searchFor = this.searchQuery
      let isEmpty = this.options.length === 0
      setTimeout(function () {
        if (this.isTyping) {
          this.searchStatisticSend(searchFor, isEmpty)
        }
      }, 500)
      this.isTyping = false
      this.close()
      this.searchQuery = ''
      this.selectedType = 0
    },
    keyDownPressed (event) {
      let key = event.keyCode || event.charCode
      if (key === 8 || key === 27 || key === 46) {
        if (this.isTyping && this.options.length === 0) {
          let searchFor = this.lastSearch
          this.searchStatisticSend(searchFor, true)
        }
        this.isTyping = false
      } else {
        this.isTyping = true
      }
    },
    searchLeave (event) {
      let searchFor = event.target.value
      if (searchFor !== '') {
        if (this.isTyping) {
          if (this.options.length > 0) {
            this.searchStatisticSend(searchFor, false)
          } else {
            this.searchStatisticSend(searchFor, true)
          }
        }
      }
    },
    searchStatisticSend (search, empty) {
      if (this.disableAPI) return
      let body = {
        request: search,
        isEmpty: empty
      }
      this.disableAPI = true
      this.$http.post(api.URLS.searchSave, body, api.headersAuthSettings).then(() => {
        this.disableAPI = false
        if (window._paq) {
          window._paq.push(['setCustomDimension', 4, search])
          window._paq.push(['setCustomUrl', '/search-query/' + search])
          window._paq.push(['setDocumentTitle', document.title])
          window._paq.push(['trackPageView'])
          window._paq.push(['deleteCustomDimension', 4])
          window._paq.push(['trackEvent', 'Search', 'wrote', search])
        }
        // if (window.ga) {
          // window.ga('set', 'dimension4', search)
          // window.ga('send', 'pageview', {
          //   page: '/search-query/' + search,
          //   title: search
          // })
          // window.ga('set', 'dimension4', null)

          // window.ga('send', 'pageview', {
          //   eventCategory: 'Search',
          //   eventAction: 'wrote',
          //   eventLabel: search,
          //   eventValue: 1,
          //   page: '/search-query/' + search
          // })
        // }
      }).catch(() => {
        this.disableAPI = false
      })
    },
    closeSearch (e) {
      let search = this.$refs.search
      let target = e.target
      if (search && search !== target && !search.contains(target)) {
        this.$nextTick(() => {
          this.closeSearchList()
        })
      }
    }
  },
  directives: {
    onClickaway
  },
  beforeDestroy () {
    document.addEventListener('click', this.closeSearch)
  },
  created () {
    this.$eventHub.$on('v-closeSearch', this.closeSearchList)
  },
  mounted () {
    this.getTypes()
    this.getTags()
    document.addEventListener('click', this.closeSearch)
  }
}
</script>

<style src="@/assets/scss/components/autocomplete-input.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// AutocompleteInput.vue?fa83693a